

function Header(props) {


    return (
        <>
            <h1 className="text-3xl font-medium mb-4">
                Hello {props.name}
            </h1>

            <p >
                I help you manage your activities :)
            </p>

        </>
    )
}

export default Header